module.exports = __webpack_public_path__ + "img/msff-vegetarian.35eb8773.svg";